window.ProductConfigurator = (function () {
  function getText(node) {
    if (!node) return '';
    return node.textContent.trim().replace(/\s+/g, ' ');
  }

  // Only direct text nodes — avoids picking up text from nested value/price children.
  function getDirectText(el) {
    if (!el) return '';
    var text = '';
    el.childNodes.forEach(function (n) { if (n.nodeType === 3) text += n.textContent; });
    text = text.trim().replace(/\s+/g, ' ');
    if (text) return text;
    var inner = el.querySelector('span, strong, b');
    return inner ? getText(inner) : getText(el);
  }

  // Strip price modifiers like "(+Rs. 1,000)" or "(Rs. 500)" for clean spec-sheet display.
  function cleanOptionValue(text) {
    return text.replace(/\s*\(\s*[+-]?\s*Rs\.?[^)]*\)/gi, '').trim();
  }

  // Priority-based option NAME reader — tries selectors one at a time so the first
  // non-empty hit wins, avoiding combined querySelector's DOM-order pitfall.
  function getApoOptionName(optionNode) {
    var nameSelectors = [
      '.mw-option__heading', 'legend', '.mw-option__label',
      '.mw-option-heading', '.mw-option-title', '.mw-option-title-text',
      '.mw-option__title', '.mw-option__name'
    ];
    for (var i = 0; i < nameSelectors.length; i++) {
      var el = optionNode.querySelector(nameSelectors[i]);
      if (el) {
        var t = getDirectText(el);
        if (t) return t;
      }
    }
    return '';
  }

  // Priority-based option VALUE reader — mirrors getSelectedText() in apo-custom.js
  // so both files agree on what "selected" means for each APO widget type.
  function getApoOptionValue(optionNode) {
    var acc = optionNode.querySelector('.mw-accumulated-title');
    if (acc && acc.textContent.trim()) return cleanOptionValue(acc.textContent.trim());

    var selectedWrappers = [
      '.mw-option__value--selected',
      '.mw-option__value--active',
      '.mw-option__value.is-selected',
      '.selectCustom-option.mw-selected',
      '.selectCustom-option[aria-selected="true"]'
    ];
    for (var j = 0; j < selectedWrappers.length; j++) {
      var wrapper = optionNode.querySelector(selectedWrappers[j]);
      if (wrapper) {
        var titleEl = wrapper.querySelector('.mw-option__value-title, .mw-option__label, .mw-option__value-text');
        var raw = titleEl ? getText(titleEl) : getText(wrapper);
        if (raw) return cleanOptionValue(raw);
      }
    }

    var sel = optionNode.querySelector('select');
    if (sel) {
      var opt = sel.options[sel.selectedIndex];
      if (opt && opt.value) return cleanOptionValue(opt.text.trim());
    }

    var checked = optionNode.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
    if (checked) {
      var lbl = checked.closest('label') ||
                (checked.id && document.querySelector('label[for="' + checked.id + '"]'));
      if (lbl) return cleanOptionValue(getText(lbl));
    }

    return '';
  }

  function normalizeOptionName(name) {
    if (!name) return '';
    return name.replace(/[:\n\r]+/g, ' ').trim();
  }

  function buildOptionEntry(optionName, optionValue, seen, selected) {
    if (!optionName || !optionValue) return;
    optionName = normalizeOptionName(optionName);
    optionValue = optionValue.trim();
    if (!optionName || !optionValue) return;
    var key = optionName + '|' + optionValue;
    if (seen.has(key)) return;
    seen.add(key);
    selected.push({ name: optionName, value: optionValue });
  }

  function extractApoOption(optionNode, seen, selected) {
    if (!optionNode) return;

    var optionName  = getApoOptionName(optionNode);
    var optionValue = getApoOptionValue(optionNode);

    if (!optionName) {
      var groupLabel = optionNode.querySelector('[data-option-group-label], .mw-option-group__title, .mw-option-group-title');
      if (groupLabel) optionName = getDirectText(groupLabel);
    }

    buildOptionEntry(optionName, optionValue, seen, selected);
  }

  function querySelectedOptions() {
    var selected = [];
    var seen = new Set();

    document.querySelectorAll('input[type="radio"][name*="option"][checked], input[type="checkbox"][name*="option"][checked], select[name*="option"]').forEach(function (control) {
      var optionName = '';
      var optionValue = '';

      if (control.tagName.toLowerCase() === 'select') {
        optionValue = control.options[control.selectedIndex]?.text || control.value;
      } else {
        optionValue = control.value;
      }

      if (control.id) {
        var label = document.querySelector('label[for="' + control.id + '"]');
        if (label) {
          var labelText = getText(label);
          if (labelText) optionValue = labelText;
        }
      }

      var fieldset = control.closest('fieldset');
      if (fieldset) {
        var legend = fieldset.querySelector('legend');
        if (legend) optionName = getText(legend);
      }

      if (!optionName) {
        var position = control.dataset.optionPosition || (control.name.match(/option(?:\[|\-|_)?(\d+)/i) || [])[1];
        if (position) optionName = 'Option ' + position;
      }

      if (!optionName) {
        optionName = control.name;
      }

      buildOptionEntry(optionName, optionValue, seen, selected);
    });

    var apoOptionNodes = document.querySelectorAll('.mw-apo-container .mw-option, .mw-apo-container .mw-option-group, .mw-apo-container [data-option-group], .mw-option');
    apoOptionNodes.forEach(function (optionNode) {
      extractApoOption(optionNode, seen, selected);
    });

    if (selected.length === 0) {
      document.querySelectorAll('.mw-apo-container [aria-selected="true"], .mw-apo-container .selected, .mw-apo-container .is-selected, .mw-apo-container input:checked').forEach(function (node) {
        var optionNode = node.closest('.mw-option') || node.closest('[data-option-group]');
        var optionName = getText(optionNode?.querySelector('.mw-option__heading, legend, .mw-option__label, .mw-option-heading, .mw-option-title, .mw-option-title-text, .mw-option__title, .mw-option__name'));
        var optionValue = getText(node);
        if (!optionValue && node.tagName.toLowerCase() === 'input') {
          var checkedLabel = document.querySelector('label[for="' + node.id + '"]');
          optionValue = getText(checkedLabel) || node.value;
        }
        buildOptionEntry(optionName, optionValue, seen, selected);
      });
    }

    return selected;
  }

  function updateSummary(panel) {
    var optionList = panel.querySelector('[data-configurator-options]');
    var priceEl = panel.querySelector('[data-configurator-price]');
    var values = querySelectedOptions();

    if (!optionList || !priceEl) return;

    if (values.length === 0) {
      optionList.innerHTML = '<div class="custom-configurator__placeholder">Your current option selections will appear here.</div>';
    } else {
      optionList.innerHTML = values.map(function (item) {
        return '<div class="custom-configurator__option"><span>' + escapeHtml(item.name) + '</span><strong>' + escapeHtml(item.value) + '</strong></div>';
      }).join('');
    }

    var pagePrice =
      document.querySelector('.product-info__price sale-price') ||
      document.querySelector('sale-price');
    if (pagePrice) {
      priceEl.textContent = pagePrice.textContent.trim().replace(/\s+/g, ' ');
    }
  }

  // ── APO CONFIG DETAIL HELPERS ────────────────────────────────

  function extractCodeFromText(text) {
    if (!text) return '';
    var matches = text.match(/\(([^)]+)\)/g) || [];
    for (var i = matches.length - 1; i >= 0; i--) {
      var inner = matches[i].replace(/[()]/g, '').trim();
      if (!inner || inner.indexOf('Rs') !== -1) continue;
      if (inner.indexOf('+') !== -1 && /\d/.test(inner)) continue;
      if (/^\d+\.\d+$/.test(inner)) continue;
      return inner;
    }
    return '';
  }

  function descriptionFromOptionText(text, code) {
    if (!text) return '';
    if (!code) return text.trim();
    return text.replace('(' + code + ')', '').replace(/\s+/g, ' ').trim();
  }

  // Reads APO option nodes only (not native Shopify variant inputs).
  // Returns [{code, description}] for the CONFIGURATION DETAILS table.
  function queryApoConfigDetails() {
    var details = [];
    var seen = new Set();
    document.querySelectorAll('.mw-apo-container .mw-option').forEach(function (optionNode) {
      if (optionNode.offsetParent === null) return; // skip hidden conditional options
      var raw = getApoOptionValue(optionNode); // includes "(CODE)" but strips Rs. price text
      if (!raw) return;
      var code = extractCodeFromText(raw);
      var desc = descriptionFromOptionText(raw, code);
      var key  = code || desc;
      if (!key || seen.has(key)) return;
      seen.add(key);
      details.push({ code: code, description: desc });
    });
    return details;
  }

  // ── SPEC SHEET DATA HELPERS ───────────────────────────────────

  function parseLines(text) {
    if (!text) return [];
    return String(text).split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean);
  }

  function parseSpecifications(text) {
    return parseLines(text).map(function (line) {
      var idx = line.indexOf(':');
      if (idx > 0) return { label: line.slice(0, idx).trim(), value: line.slice(idx + 1).trim() };
      return { label: line, value: '' };
    });
  }

  function getSkuForPdf() {
    var el = document.getElementById('apo-generated-sku');
    if (el && el.textContent.trim() && el.textContent.trim() !== '—') return el.textContent.trim();
    var native = document.querySelector('.product-info__sku, variant-sku');
    return native ? native.textContent.replace(/^SKU:\s*/i, '').trim() : '';
  }

  function pdfDateShort() {
    var d = new Date();
    var mm = String(d.getMonth() + 1).padStart(2, '0');
    var dd = String(d.getDate()).padStart(2, '0');
    var yy = String(d.getFullYear()).slice(-2);
    return mm + '/' + dd + '/' + yy;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function showPdfPreview(blobUrl, title) {
    var old = document.getElementById('spec-pdf-modal');
    if (old) old.remove();

    var modal = document.createElement('div');
    modal.id = 'spec-pdf-modal';
    modal.style.cssText = [
      'position:fixed;inset:0;z-index:99999',
      'background:rgba(0,0,0,0.72)',
      'display:flex;align-items:center;justify-content:center',
      'padding:16px'
    ].join(';');

    var box = document.createElement('div');
    box.style.cssText = [
      'width:min(92vw,860px);height:88vh',
      'background:#fff;border-radius:10px',
      'display:flex;flex-direction:column',
      'overflow:hidden',
      'box-shadow:0 24px 64px rgba(0,0,0,0.35)'
    ].join(';');

    var bar = document.createElement('div');
    bar.style.cssText = [
      'display:flex;align-items:center;justify-content:space-between',
      'padding:12px 16px',
      'background:#f7f7f7;border-bottom:1px solid #e2e2e2',
      'flex-shrink:0'
    ].join(';');

    var barTitle = document.createElement('span');
    barTitle.textContent = title || 'Specification Sheet';
    barTitle.style.cssText = 'font-size:13px;font-weight:600;color:#222;';

    var btnWrap = document.createElement('div');
    btnWrap.style.cssText = 'display:flex;gap:8px;align-items:center;';

    var dlBtn = document.createElement('a');
    dlBtn.href = blobUrl;
    dlBtn.download = (title || 'specification') + '.pdf';
    dlBtn.textContent = 'Download';
    dlBtn.style.cssText = [
      'padding:5px 14px;font-size:12px;font-weight:600',
      'background:#111;color:#fff;border-radius:5px',
      'text-decoration:none;cursor:pointer'
    ].join(';');

    var closeBtn = document.createElement('button');
    closeBtn.textContent = '✕  Close';
    closeBtn.style.cssText = [
      'padding:5px 14px;font-size:12px;font-weight:600',
      'background:#e8e8e8;color:#333;border:none;border-radius:5px;cursor:pointer'
    ].join(';');
    closeBtn.addEventListener('click', function () { modal.remove(); });

    btnWrap.appendChild(dlBtn);
    btnWrap.appendChild(closeBtn);
    bar.appendChild(barTitle);
    bar.appendChild(btnWrap);

    var iframe = document.createElement('iframe');
    iframe.src = blobUrl;
    iframe.style.cssText = 'flex:1;border:none;width:100%;';

    box.appendChild(bar);
    box.appendChild(iframe);
    modal.appendChild(box);
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) { if (e.target === modal) modal.remove(); });
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') { modal.remove(); document.removeEventListener('keydown', esc); }
    });
  }

  function loadJsPDF(callback) {
    if (window.jspdf?.jsPDF || window.jsPDF) {
      callback();
      return;
    }

    var existing = document.querySelector('script[src*="jspdf.umd.min.js"]');
    if (existing) {
      existing.addEventListener('load', callback);
      return;
    }

    var script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
    script.onload = callback;
    script.onerror = function () {
      console.warn('Could not load jsPDF. Falling back to window.print().');
      callback();
    };
    document.body.appendChild(script);
  }

  function loadImageAsDataURL(url, callback) {
    if (!url) { callback(null); return; }
    try {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          callback(canvas.toDataURL('image/jpeg', 0.85));
        } catch (error) {
          callback(null);
        }
      };
      img.onerror = function () { callback(null); };
      img.src = url;
    } catch (error) {
      callback(null);
    }
  }

  function getProductImageUrl() {
    var image = document.querySelector('.product-gallery__media:not([hidden]) img, .product-gallery__media img, .product-media img, .product__image img, .product__media img');
    if (image && image.src) return image.src;
    return null;
  }

  function formatDate(date) {
    return date.toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' });
  }

  function generatePdf(panel) {
    var title         = ((document.querySelector('.product-info__title') || {}).textContent || document.title).trim();
    var sku           = getSkuForPdf();
    var configDetails = queryApoConfigDetails();
    var specData      = window.specSheetData || {};
    var brandName     = (specData.brandName    || '').trim();
    var features      = parseLines(specData.features      || '');
    var specLines     = parseLines(specData.specifications || ''); // rendered as bullets
    var sustain       = parseLines(specData.sustainability || '');
    var footerUrl     = (specData.footerUrl  || '').trim();
    var footerNote    = (specData.footerNote || '').trim();
    var imageUrl      = getProductImageUrl();

    function buildDoc(imageData) {
      var jsPDFCtor = (window.jspdf && window.jspdf.jsPDF) || window.jsPDF;
      if (!jsPDFCtor) { window.print(); return; }

      var doc = new jsPDFCtor({ unit: 'pt', format: 'a4' });
      var PW  = doc.internal.pageSize.getWidth();   // 595.28
      var PH  = doc.internal.pageSize.getHeight();  // 841.89
      var ML  = 42;
      var MR  = 42;
      var MT  = 38;
      var MB  = 42;
      var CW  = PW - ML - MR;
      var y   = MT;

      // Palette
      var C_TEAL  = [45, 90, 74];   // dark teal — section header bg
      var C_DARK  = [22, 22, 22];
      var C_MID   = [55, 55, 55];
      var C_GRAY  = [130, 130, 130];
      var C_WHITE = [255, 255, 255];
      var C_RULE  = [205, 205, 205];

      // ── helpers ──────────────────────────────────────────────

      function guard(need) {
        if (y + need > PH - MB) { doc.addPage(); y = MT; }
      }

      function hRule(r, g, b) {
        doc.setDrawColor(r || C_RULE[0], g || C_RULE[1], b || C_RULE[2]);
        doc.setLineWidth(0.4);
        doc.line(ML, y, PW - MR, y);
      }

      // Dark-teal filled bar with white caps label
      function sectionHeader(label) {
        guard(24);
        y += 9;
        doc.setFillColor(C_TEAL[0], C_TEAL[1], C_TEAL[2]);
        doc.rect(ML, y - 11, CW, 15, 'F');
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(8.5);
        doc.setTextColor(C_WHITE[0], C_WHITE[1], C_WHITE[2]);
        doc.text(label, ML + 5, y);
        y += 9;
        doc.setTextColor(C_DARK[0], C_DARK[1], C_DARK[2]);
      }

      function bulletList(items) {
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(8.5);
        doc.setTextColor(C_MID[0], C_MID[1], C_MID[2]);
        items.forEach(function (line) {
          if (!line) return;
          guard(13);
          var wrapped = doc.splitTextToSize('•  ' + line, CW - 14);
          doc.text(wrapped, ML + 8, y);
          y += wrapped.length * 11.5 + 2.5;
        });
      }

      // ── TOP BAR ───────────────────────────────────────────────
      // Left: "Specification Sheet"   Right: brand name (serif)

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(8.5);
      doc.setTextColor(C_GRAY[0], C_GRAY[1], C_GRAY[2]);
      doc.text('Specification Sheet', ML, y);

      if (brandName) {
        doc.setFont('times', 'italic');
        doc.setFontSize(21);
        doc.setTextColor(C_DARK[0], C_DARK[1], C_DARK[2]);
        doc.text(brandName, PW - MR, y, { align: 'right' });
      }

      y += 9;
      hRule();
      y += 16;

      // ── TWO-COLUMN HEADER: image (left) | product info (right) ─

      var IMG_W  = 170;
      var IMG_H  = 155;
      var COL_G  = 22;
      var INFO_X = ML + IMG_W + COL_G;
      var INFO_W = CW - IMG_W - COL_G;

      var infoY = y;

      if (imageData) {
        doc.addImage(imageData, 'JPEG', ML, y, IMG_W, IMG_H);
      }

      // Product name
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(14);
      doc.setTextColor(C_DARK[0], C_DARK[1], C_DARK[2]);
      var titleWrapped = doc.splitTextToSize(title, INFO_W);
      doc.text(titleWrapped, INFO_X, infoY);
      infoY += titleWrapped.length * 17 + 10;

      // Model number (bold label + bold value)
      if (sku) {
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(8.5);
        doc.setTextColor(C_DARK[0], C_DARK[1], C_DARK[2]);
        doc.text('Model Number: ', INFO_X, infoY);
        var labelW = doc.getTextWidth('Model Number: ');
        doc.setFont('helvetica', 'normal');
        var skuWrapped = doc.splitTextToSize(sku, INFO_W - labelW);
        doc.text(skuWrapped, INFO_X + labelW, infoY);
        infoY += skuWrapped.length * 12 + 4;
      }

      // Push y past the image/info block (whichever is taller)
      y = Math.max(y + IMG_H + 10, infoY + 10);

      hRule();
      y += 14;

      // ── FEATURES ─────────────────────────────────────────────

      if (features.length) {
        sectionHeader('FEATURES');
        y += 5;
        bulletList(features);
        y += 2;
      }

      // ── SPECIFICATIONS ────────────────────────────────────────

      if (specLines.length) {
        sectionHeader('SPECIFICATIONS');
        y += 5;
        bulletList(specLines);
        y += 2;
      }

      // ── CONFIGURATION DETAILS ─────────────────────────────────

      if (configDetails.length) {
        sectionHeader('CONFIGURATION DETAILS');
        y += 8;

        var codeColW = 52;
        var descColW = CW - codeColW - 10;

        // Column header row
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(8.5);
        doc.setTextColor(C_DARK[0], C_DARK[1], C_DARK[2]);
        doc.text('CODE', ML + 2, y);
        doc.text('DESCRIPTION', ML + codeColW + 10, y);
        y += 5;
        doc.setDrawColor(170, 170, 170);
        doc.setLineWidth(0.3);
        doc.line(ML, y, PW - MR, y);
        y += 9;

        // Data rows
        doc.setFontSize(8.5);
        configDetails.forEach(function (row) {
          var descText    = row.code ? '- ' + row.description : row.description;
          var descWrapped = doc.splitTextToSize(descText, descColW);
          var rowH        = Math.max(descWrapped.length * 11.5, 11.5) + 4;
          guard(rowH + 2);
          doc.setFont('helvetica', 'bold');
          doc.setTextColor(C_DARK[0], C_DARK[1], C_DARK[2]);
          doc.text(row.code || '', ML + 2, y);
          doc.setFont('helvetica', 'normal');
          doc.setTextColor(C_MID[0], C_MID[1], C_MID[2]);
          doc.text(descWrapped, ML + codeColW + 10, y);
          y += rowH;
        });
        y += 2;
      }

      // ── SUSTAINABILITY ────────────────────────────────────────

      
        sectionHeader('SUSTAINABILITY');
        y += 5;
        bulletList(sustain);
        y += 2;


      // ── FIND OUT MORE ─────────────────────────────────────────

      if (footerUrl || footerNote) {
        sectionHeader('FIND OUT MORE');
        y += 5;
        if (footerUrl) {
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(8.5);
          doc.setTextColor(0, 80, 180);
          doc.text(footerUrl, ML + 8, y);
          y += 13;
        }
        if (footerNote) {
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(7.5);
          doc.setTextColor(C_GRAY[0], C_GRAY[1], C_GRAY[2]);
          var noteWrapped = doc.splitTextToSize(footerNote, CW - 10);
          doc.text(noteWrapped, ML + 8, y);
          y += noteWrapped.length * 10 + 2;
        }
      }

      // ── PAGE FOOTER ───────────────────────────────────────────

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(7);
      doc.setTextColor(190, 190, 190);
      doc.text('Generated on ' + new Date().toLocaleString(), ML, PH - 20);

      showPdfPreview(doc.output('bloburl'), title);
    }

    loadJsPDF(function () {
      if (!imageUrl) { buildDoc(null); return; }
      loadImageAsDataURL(imageUrl, buildDoc);
    });
  }

  function initPanel(panel) {
    var toggle = panel.querySelector('[data-configurator-toggle]');
    var content = panel.querySelector('[data-configurator-panel]');
    var pdfButton = panel.querySelector('[data-configurator-pdf]');

    if (!toggle || !content || !pdfButton) return;

    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      content.hidden = expanded;
      updateSummary(panel);
    });

    pdfButton.addEventListener('click', function (event) {
      event.preventDefault();
      updateSummary(panel);
      generatePdf(panel);
    });

    document.addEventListener('click', function (event) {
      if (event.target.closest('.product-info') || event.target.closest('.variant-picker') || event.target.closest('.mw-apo-container')) {
        updateSummary(panel);
      }
    });

    var apoNode = document.querySelector('.mw-apo-container');
    if (apoNode && window.MutationObserver) {
      new MutationObserver(function () {
        updateSummary(panel);
      }).observe(apoNode, { childList: true, subtree: true, characterData: true });
    }

    updateSummary(panel);
  }

  function init() {
    document.querySelectorAll('[data-custom-configurator]').forEach(initPanel);
  }

  return {
    init: init
  };
})();

document.addEventListener('DOMContentLoaded', function () {
  window.ProductConfigurator.init();
});
